import { regular } from "@fortawesome/fontawesome-svg-core/import.macro"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React, { useEffect } from "react"
import { Heading3 } from "../typography/headings"
import { BodyTextRegular } from "../typography/text"
import { ButtonAction } from "../button/ButtonAction"

type Props = {
  header: string
  subtitle: string
  buttonText: string
  buttonOnClick: () => void | Promise<void>
}

export const ActionFailedTemplate = ({
  header,
  subtitle,
  buttonOnClick,
  buttonText,
}: Props) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }, [])

  return (
    <div className="flex h-[75vh] items-center flex-col w-fit self-center pl-4 pr-4 md:pl-[100px] md:pr-[100px]">
      <div className="flex mt-[100px] mb-8 w-[72px] h-[72px] bg-tag-red-bg rounded-full justify-center items-center">
        <FontAwesomeIcon
          className="text-foreground-error"
          fontSize="40px"
          icon={regular("exclamation")}
        />
      </div>
      <Heading3 className="mb-4 text-foreground-base">{header}</Heading3>
      <BodyTextRegular className="text-center text-foreground-subtle w-auto md:w-[440px]">
        {subtitle}
      </BodyTextRegular>
      <ButtonAction
        className="mt-16 w-full max-w-[350px]"
        size="large"
        onClick={buttonOnClick}
      >
        {buttonText}
      </ButtonAction>
    </div>
  )
}
